import axios from "axios";
const { VUE_APP_VT_DOCS, VUE_APP_API_URL, VUE_APP_VT_API_URL } = process.env;

const fetchAdhocDocuments = async (booking) => {
  try {
    const res = await axios.get(
      `${VUE_APP_VT_DOCS}/fetch-booking-adhoc/${booking}`
    );
    if (res && res.data && res.status === 200) {
      return res;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
};

const fetchSupplierProgress = async (booking, supplier) => {
  try {
    const res = await axios.get(
      `${VUE_APP_VT_DOCS}/check-supplier-progress/${booking}/${supplier}`
    );
    if (res && res.data && res.status === 200) {
      return res;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
};

const fetchSupplierWebURL = async (formName, supplier) => {
  try {
    const res = await axios.get(
      `${VUE_APP_VT_DOCS}/get-supplier-web-url/${formName}/${supplier}`
    );
    if (res && res.data && res.status === 200) {
      return res;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
};

const fetchAdhocWebURL = async (formName) => {
  try {
    const res = await axios.get(
      `${VUE_APP_VT_DOCS}/get-adhoc-web-url/${formName}`
    );
    if (res && res.data && res.status === 200) {
      return res;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
};

const completeSupplierFilePerGroupService = async (
  booking,
  formName,
  supplier
) => {
  try {
    const res = await axios.get(
      `${VUE_APP_VT_DOCS}/complete-onlineform-pergroup/${booking}/${formName}/${supplier}`
    );
    if (res && res.data && res.status === 200) {
      return res;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
};

const completeSupplierFilePerPersonService = async (
  booking,
  formName,
  supplier,
  client
) => {
  try {
    const res = await axios.get(
      `${VUE_APP_VT_DOCS}/complete-onlineform-perperson/${booking}/${formName}/${supplier}/${client}`
    );
    if (res && res.data && res.status === 200) {
      return res;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
};

const completeAdhocFilePerGroupService = async (booking, formName) => {
  try {
    const res = await axios.get(
      `${VUE_APP_VT_DOCS}/complete-onlineform-adhoc-pergroup/${booking}/${formName}`
    );
    if (res && res.data && res.status === 200) {
      return res;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
};

const completeAdhocFilePerPersonService = async (booking, formName, client) => {
  try {
    const res = await axios.get(
      `${VUE_APP_VT_DOCS}/complete-onlineform-adhoc-perperson/${booking}/${formName}/${client}`
    );
    if (res && res.data && res.status === 200) {
      return res;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
};

const uploadSupplierFilePerGroupService = async (
  booking,
  formName,
  supplier,
  file
) => {
  try {
    const res = await axios.post(
      `${VUE_APP_VT_DOCS}/upload-client-file-pergroup/${booking}/${formName}/${supplier}`,
      file,
      {
        headers: {
          "Content-Type": undefined,
        },
      }
    );
    if (res && res.data && res.status === 200) {
      return res;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
};

const uploadSupplierFilePerPersonService = async (
  booking,
  formName,
  supplier,
  client,
  file
) => {
  try {
    const res = await axios.post(
      `${VUE_APP_VT_DOCS}/upload-client-file-perperson/${booking}/${formName}/${supplier}/${client}`,
      file,
      {
        headers: {
          "Content-Type": undefined,
        },
      }
    );
    if (res && res.data && res.status === 200) {
      return res;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
};

const uploadAdhocFilePerGroupService = async (booking, formName, file) => {
  try {
    const res = await axios.post(
      `${VUE_APP_VT_DOCS}/upload-client-adhocfile-pergroup/${booking}/${formName}`,
      file,
      {
        headers: {
          "Content-Type": undefined,
        },
      }
    );
    if (res && res.data && res.status === 200) {
      return res;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
};

const uploadAdhocFilePerPersonService = async (
  booking,
  formName,
  client,
  file
) => {
  try {
    const res = await axios.post(
      `${VUE_APP_VT_DOCS}/upload-client-adhocfile-perperson/${booking}/${formName}/${client}`,
      file,
      {
        headers: {
          "Content-Type": undefined,
        },
      }
    );
    if (res && res.data && res.status === 200) {
      return res;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
};

const updateSecureDetails = async (
  booking,
  formName,
  supplier,
  client,
  type,
  data
) => {
  try {
    const res = await axios.post(
      `${VUE_APP_VT_DOCS}/update-details/${booking}/${formName}/${supplier}/${client}/${type}`,
      data
    );
    if (res && res.data && res.status === 200) {
      return res;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
};

const fetchSupplierRecord = async (id, session) => {
  try {
    const res = await axios.get(
      `${VUE_APP_VT_API_URL}/vt-api/viewtrail/essential/product-record/supplier/${id}?&sessionnum=${session}`
    );
    if (res && res.data && res.status === 200) {
      return res.data;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
};

const fetchDestinationRecord = async (id, session) => {
  try {
    const res = await axios.get(
      `${VUE_APP_VT_API_URL}/vt-api/viewtrail/essential/product-record/destination/${id}?&sessionnum=${session}`
    );
    if (res && res.data && res.status === 200) {
      return res.data;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
};

const fetchCheckInRecord = async (id, session) => {
  try {
    const res = await axios.get(
      `${VUE_APP_VT_API_URL}/vt-api/viewtrail/essential/check-in-record/supplier/${id}?&sessionnum=${session}`
    );
    if (res && res.data && res.status === 200) {
      return res.data;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
};

const fetchVoucherRecord = async (id, session) => {
  try {
    const res = await axios.get(
      `${VUE_APP_VT_API_URL}/vt-api/viewtrail/essential/voucher-record/supplier/${id}?&sessionnum=${session}`
    );
    if (res && res.data && res.status === 200) {
      return res.data;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
};

const fetchVilla = async (villaId, supplier) => {
  try {
    let url = "";
    if (supplier === "cv") {
      url = `${VUE_APP_API_URL}/api/villas/find-villa/${villaId}`;
    } else if (supplier === "solmar") {
      url = `${VUE_APP_API_URL}/api/villas/solmar/${villaId}`;
    }

    const res = await axios.get(url);
    if (res && res.data) {
      return res.data;
    }
  } catch (err) {
    return null;
  }
};

const reportVoucherError = async (bookno, data) => {
  const { groupdate, supplier, title } = data;
  try {
    const emailData = {
      from: "donotreply@trailfinders.com",
      send_to:
        process.env === "production"
          ? "ian.thorpe@trailfinders.com"
          : "devops@trailfinders.com",
      subject: `Missing ViewTrail voucher information - ${bookno} - ${groupdate} - ${supplier}`,
      email_body: `
      <div style="font-family:Arial;font-size:14px;">
        <span>Missing voucher information - ${bookno} - ${title} - ${groupdate} - ${supplier}</span></br></br>
        <p>The below conditions were checked (in order), but none were met:</p>
        <p>- tfvouch_status = 'ISSUED' + page 2 vouchno = populated</p>
        <p>- suppdoclink = true + supdocslist = populated</p>
        <p>- suppdoclink = true + additionalsuppdoclist = populated</p>
        <p>- essential information contains voucher information</p>
        <p>- tfvouch_status = 'NOT YET READY' or 'NOT REQUIRED'</p>
      </div>
      `,
      inc_headers_footers: false,
      inc_awards: false,
      version: "1",
      bookno: bookno,
    };
    const res = await axios.post(`${VUE_APP_API_URL}/api/email`, emailData);
    if (res && res.data && res.status === 200) {
      return res.data;
    }
  } catch (err) {
    return null;
  }
};

const fetchVoucherInformation = async (data) => {
  const voucherInfoString = data.toLowerCase().replace(/ /g, "-")
  try {
    const res = await axios.get(
      `${VUE_APP_VT_API_URL}/vt-api/viewtrail/essential/voucher-status/${voucherInfoString}`
    );
    if (res && res.data && res.status === 200) {
      return res.data;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
};

export {
  fetchAdhocDocuments,
  fetchSupplierProgress,
  completeSupplierFilePerGroupService,
  fetchSupplierWebURL,
  fetchAdhocWebURL,
  completeAdhocFilePerGroupService,
  uploadAdhocFilePerGroupService,
  uploadSupplierFilePerGroupService,
  completeSupplierFilePerPersonService,
  completeAdhocFilePerPersonService,
  uploadSupplierFilePerPersonService,
  uploadAdhocFilePerPersonService,
  updateSecureDetails,
  fetchSupplierRecord,
  fetchDestinationRecord,
  fetchCheckInRecord,
  fetchVoucherRecord,
  fetchVilla,
  reportVoucherError,
  fetchVoucherInformation
};
